<template>
  <div>
    <!-- Overlay com indicador de progresso -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="flex flex-col">
      <div class="flex-1 bg-white shadow-xl">
        <v-data-table :headers="headers" :items="vendas" :items-per-page="8">
          <!-- Coluna de índice -->
          <template v-slot:item.indice="{ item }">
            <span>{{ indexOfItem(item) }}</span>
          </template>
          <!-- Colunas formatadas com utilitários -->
          <template v-slot:item.ValorAPagar="{ item }">
            <span>{{ formatMoney(item.ValorAPagar) }}</span>
          </template>
          <template v-slot:item.valorPago="{ item }">
            <span>{{ formatMoney(item.valorPago) }}</span>
          </template>
          <template v-slot:item.desconto="{ item }">
            <span>{{ formatMoney(item.desconto) }}</span>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import _axios from '@/plugins/axios';
import utilitarios from '@/plugins/utilitarios';
import Swal from 'sweetalert2';

export default {
  props: {
    estudante: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      overlay: false,
      vendas: [],
      headers: [
        { text: '#', value: 'indice' },
        { text: 'Autor', align: 'start', sortable: false, value: 'autor' },
        { text: 'Factura', value: 'numeroFatura' },
        { text: 'Estudante', value: 'cliente' },
        { text: 'Operação', value: 'operacao' },
        { text: 'Valor A Pago', value: 'ValorAPagar' },
        { text: 'Valor Pago', value: 'valorPago' },
        { text: 'Desconto', value: 'desconto' },
        { text: 'Data de Realização', value: 'data_realizacao' },
        { text: 'Última Actualização', value: 'modifiedAt' }
      ]
    };
  },
  watch: {
    estudante: {
      immediate: true,
      handler(newEstudante) {
        if (newEstudante) {
          this.pesquisarVendas();
        }
      }
    }
  },
  methods: {
    formatMoney(value) {
      return utilitarios.IntegerToMoneyValueFatura(value);
    },
    indexOfItem(item) {
      return this.vendas.indexOf(item) + 1;
    },
    async pesquisarVendas() {
      try {
        this.overlay = true;
        this.vendas = [];

        if (!this.estudante || !this.estudante.numero_matricula) {
          throw new Error('Estudante inválido');
        }

        const response = await _axios.get(`/registroEstudante/${this.estudante.numero_matricula}`);
        this.vendas = response.data;
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante a listagem dos pagamentos!', 'error');
      } finally {
        this.overlay = false;
      }
    }
  }
};
</script>

<style scoped>
.table_data, .table_head {
  padding: 0.5rem 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.75rem;
}

.table-full {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  text-align: center;
}
</style>
